import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  GET_USER_PROFILE_MESSAGE_TYPE,
  setUserProfile,
  type UserProfile,
} from '@leagueplatform/user-profile-api';

export const useUpdateEmailNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (
      params: Pick<UserProfile, 'opted_into_marketing_communications'>,
    ) => setUserProfile(params),
    onSuccess: () => {
      queryClient.invalidateQueries([GET_USER_PROFILE_MESSAGE_TYPE]);
    },
  });
};
